import FormatBoldIcon from "@mui/icons-material/FormatBold";
import DashboardIcon from "./assets/sidenav/dashboard.svg";
import cmsIcon from "./assets/sidenav/cms.svg";
import DashboardIconWhite from "./assets/sidenav/white/dashboard.svg";
import AccountIcon from "./assets/sidenav/accounts.svg";
import InstantIcon from "./assets/sidenav/instant.svg";
import UserIcon from "./assets/sidenav/user.svg";
import user1 from "./assets/sidenav/UserR.svg";
import FlightIcon from "./assets/sidenav/flight_booking.svg";
import AepsIcon from "./assets/sidenav/aeps.svg";
import BbpsIcon from "./assets/sidenav/bbps.svg";
import CreditRequestIcon from "./assets/sidenav/credit_request.svg";
import ExpressIcon from "./assets/sidenav/express_transfer.svg";
import MoneyTransferIcon from "./assets/sidenav/money_transfer.svg";
import NepalIcon from "./assets/sidenav/nepal1.png";
import RechargeIcon from "./assets/sidenav/recharge_bill.svg";
import ReportsIcon from "./assets/sidenav/reports.svg";
import Arrow from "./assets/sidenav/arrows.png";
import upi from "./assets/sidenav/upi-transfer.svg";
import nepal2 from "./assets/sidenav/nepal-flag-icon.svg";
import UpiIcon from "./assets/sidenav/upi_transfer.svg";
import employeesIcon from "./assets/sidenav/employee_icon.svg";
import AccountIconWhite from "./assets/sidenav/white/accounts.svg";
import BankIconWhite from "./assets/sidenav/white/bank.svg";
import ComplaintsIconWhite from "./assets/sidenav/white/complaints.svg";
import TransactionIconWhite from "./assets/sidenav/white/transactions.svg";
import UserIconWhite from "./assets/sidenav/white/user.svg";
import InstantIconWhite from "./assets/sidenav/white/instant.svg";
import cmsIconWhite from "./assets/sidenav/white/cms.svg";
import employeesIconWhite from "./assets/sidenav/white/employee_icon_white.svg";
import trainIconWhite from "./assets/sidenav/white/train.svg";
import dashboards from "./assets/sidenav/DashboardR.svg";
import employee1 from "./assets/sidenav/employee1.svg";
import operator1 from "./assets/sidenav/ServiceR.svg";
import plan1 from "./assets/sidenav/plan1.svg";
import virtualaccount1 from "./assets/sidenav/virtualaccount1.svg";
import complaint1 from "./assets/sidenav/complainR.svg";
import risk1 from "./assets/sidenav/risk1.svg";
import mypurchase from "./assets/sidenav/mypurchase.svg";
import train from "./assets/sidenav/train.svg";
import Upi from "./assets/sidenav/Upi.svg";
import creditmoney from "./assets/sidenav/creditmoney.svg";
import Reports1 from "./assets/sidenav/Reports1.svg";
import Recharge from "./assets/sidenav/Recharge.svg";
import mservice from "./assets/sidenav/mservice.svg";
import Travel from "./assets/sidenav/Travel.svg";
import AEPS1 from "./assets/sidenav/AEPS1.svg";
import complaint from "./assets/sidenav/complaint.svg";
import Cms2 from "./assets/sidenav/Cms2.svg";
import graph from "./assets/sidenav/txnR.svg";
import Book from "./assets/sidenav/book.svg";
import Leave from "./assets/sidenav/leave.svg";
import Task from "./assets/sidenav/task.svg";
import Project from "./assets/sidenav/project.svg";
import Login from "./assets/sidenav/login.svg";
import User2 from "./assets/sidenav/user2.svg";
import DASH from "./assets/sidenav/dash.svg";
import UTILITY from "./assets/sidenav/UTILITY.svg";
import Logout1 from "./assets/sidenav/logout1.svg";
import Attend from "./assets/sidenav/attend.svg";
import Attend1 from "./assets/sidenav/attend1.svg";
import bharatbig from "./assets/sidenav/bharatbig.svg";
import loginhistory from "./assets/sidenav/loginhistory.svg";
import ledgerIcon from "./assets/ledger.svg";
import mysale from "./assets/sidenav/white/mysale.svg";
// import transactionsvg from "./assets/sidenav/transaction.svg"
import transactionsvg from "./assets/sidenav/transactionsvg.svg";
import bankingsvg from "./assets/sidenav/bankingsvg.svg";
import messagesvg from "./assets/sidenav/messagesvg.svg";
import servicesvg from "./assets/sidenav/servicesvg.svg";
import dashbaordsvg from "./assets/sidenav/dashboardsvg.svg";
import complaintsvg from "./assets/sidenav/complaintsvg.svg";
import virtualaccountsvg from "./assets/sidenav/virtualaccountsvg.svg";
import schemesvg from "./assets/sidenav/schemesvg.svg";
import employeesvg from "./assets/sidenav/employeesvg.svg";
import invoicesvg from "./assets/sidenav/envoicesvg.svg";
import usersvg from "./assets/sidenav/usersvg.svg";
import creditsvg from "./assets/sidenav/creditcardsvg.svg";
import risksvg from "./assets/sidenav/risksvg.svg";
import purchasesvg from "./assets/sidenav/purchasesvg.svg";
import {
  account_ledgre,
  aepsIcon,
  bbIcon,
  cardIcon,
  creditReq,
  dashboard,
  dthIcon,
  elecIcon,
  etIcon,
  gasIcon,
  khataBook,
  mtIcon,
  myComplaints,
  myPurchase,
  ntIcon,
  stIcon,
  transactions,
  utIcon,
  Electricity,
  FASTag,
  Cylinder,
  Postpaid,
  Prepaid,
  Gas,
  BBPS,
  licIcon,
  waterIcon,
  landIcon,
  flightBooking,
  hotelBooking,
  busBooking,
  CMSIcon,
  irctcTravelImage,
} from "./iconsImports";
import { complaintsBadgeIcon, creditReqBadgeIcon } from "./iconsImports";
export const nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/dashboard",
  },
  {
    title: "Recharge",
    icon: RechargeIcon,
    icon2: RechargeIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Money Transfer",
    icon: MoneyTransferIcon,
    icon2: MoneyTransferIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Express Transfer",
    icon: ExpressIcon,
    icon2: ExpressIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "UPI Transfer",
    icon: UpiIcon,
    icon2: UpiIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "AEPS",
    icon: AepsIcon,
    icon2: AepsIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Transaction",
    icon: InstantIcon,
    icon2: InstantIconWhite,
    to: "/dashboard/transaction",
  },
  {
    title: "Fund Request",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Contact Us",
    icon: InstantIcon,
    icon2: InstantIconWhite,
    to: "/dashboard/transaction",
  },
];
export const Admin_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/admin/dashboard",
  },
  {
    title: "Users",
    icon: User2,
    icon2: UserIconWhite,
    to: "/admin/users",
  },
  {
    title: "Projects",
    icon: Project,
    icon2: ledgerIcon,
    to: "/admin/project",
  },
  {
    title: "Tasks",
    icon: Task,
    icon2: ledgerIcon,
    to: "/admin/task",
  },
  {
    title: "Assets",
    icon: Task,
    icon2: ledgerIcon,
    to: "/admin/assets",
  },
  {
    title: "Invoices",
    icon: Task,
    icon2: ledgerIcon,
    to: "/admin/invoices",
  },
  {
    title: "Utils",
    icon: UTILITY,
    to: "/admin/utility",
  },
  {
    title: "Employee",
    icon: UTILITY,
    to: "/admin/clients",
    subMenu: [
      {
        title: "Attendance",
        to: "/admin/attendance",
        icon: Attend,
        icon2: Attend1,
      },
      {
        title: "Visits",
        to: "/admin/visits",
        icon: Attend,
        icon2: Attend1,
      },
      {
        title: "Employee Leaves",
        to: "/admin/employeeleave",
        icon: Leave,
        icon2: ledgerIcon,
      },
      // {
      //   title: "Leaves",
      //   to: "/admin/totalleave",
      //   icon: Leave,
      //   icon2: ledgerIcon
      // },
      // {
      //   title: "Leave Request",
      //   to: "/admin/leave",
      //   icon: Leave,
      //   icon2: ledgerIcon
      // },
      {
        title: "Salary",
        to: "/admin/salary",
        icon: Leave,
        icon2: ledgerIcon,
      },
      {
        title: "Employee",
        to: "/admin/employee",
        icon: Leave,
        icon2: ledgerIcon,
      },
    ],
  },
  {
    title: "Login History",
    icon: Login,
    to: "/admin/loginHistory",
  },
];

export const Asm_nav = [
  {
    title: "Employee",
    icon: UTILITY,
    to: "/asm/clients",
    subMenu: [
      {
        title: "Attendance",
        to: "/asm/attendance",
        icon: Attend,
        icon2: Attend1,
      },
      {
        title: "Visits",
        to: "/asm/visits",
        icon: Attend,
        icon2: Attend1,
      },
      {
        title: "Employee Leaves",
        to: "/asm/employeeleave",
        icon: Leave,
        icon2: ledgerIcon,
      },
    ],
  },
  {
    title: "Login History",
    icon: Login,
    to: "/asm/loginHistory",
  },
];
export const Zsm_nav = [
  {
    title: "Dashboard",
    icon: DashboardIcon,
    icon2: DashboardIconWhite,
    to: "/zsm/dashboard",
  },
  {
    title: "Users",
    icon: UserIcon,
    icon2: UserIconWhite,
    to: "/zsm/users",
  },
  {
    title: "Transactions",
    icon: graph,
    icon2: ReportsIcon,
    to: "/zsm/transactions",
  },
  {
    title: "Fund Requests",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/zsm/cred-req",
  },
  // {
  //   title: "Invoices",
  //   icon: employee1,
  //   icon2: employeesIconWhite,
  //   to: "/zsm/invoice",
  // },
  {
    title: "Login History",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/zsm/loginHistory",
  },
];
export const Api_nav = [
  {
    title: "Dashboard",
    icon: dashbaordsvg,
    icon2: DashboardIconWhite,
    to: "/api-user/dashboard",
  },
  {
    title: "Transactions",
    icon: transactionsvg,
    icon2: ReportsIcon,
    to: "/api-user/transactions",
  },
  {
    title: "Fund Requests",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/api-user/cred-req",
  },
  {
    title: "Invoices",
    icon: employee1,
    icon2: employeesIconWhite,
    to: "/api-user/invoice",
  },
  // {
  //   title: "Documents",
  //   icon: employee1,
  //   icon2: employeesIconWhite,
  //   to: "/api-user/documents",
  // },
  // {
  //   title: "Invoices",
  //   icon: invoicesvg,
  //   icon2: employeesIconWhite,
  //   to: "/api-user/invoice",
  // },
  {
    title: "Login History",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/api-user/loginHistory",
  },
];

export const Ad_nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/ad/dashboard",
  },
  {
    title: "Users",
    icon: usersvg,
    icon2: UserIconWhite,
    to: "/ad/users",
  },
  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/ad/account-ledger",
  },
  {
    title: "Fund Requests",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/ad/cred-req",
  },
  {
    title: "Transactions",
    icon: graph,
    icon2: ReportsIcon,
    to: "/ad/transactions",
  },
  {
    title: "Invoices",
    icon: employee1,
    icon2: employeesIconWhite,
    to: "/ad/invoice",
  },
  {
    title: "Login History",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/ad/loginHistory",
  },
  // {
  //   title: "My Sale",
  //   icon: TransactionIcon,
  //   icon2: TransactionIconWhite,
  //   to: "/ad/sale",
  // },
  // {
  //   title: "Credit Report",
  //   icon: TransactionIcon,
  //   icon2: TransactionIconWhite,
  //   to: "/ad/purchase",
  // },
  // {
  //   title: "My Ledger",
  //   icon: TransactionIcon,
  //   icon2: TransactionIconWhite,
  //   to: "/ad/ledger",
  // },
  // {
  //   title: "Khata Book",
  //   icon: AccountIcon,
  //   icon2: AccountIcon,
  //   to: "/ad/khata-book",
  // },
];

export const Md_nav = [
  {
    title: "Dashboard",
    icon: DashboardIcon,
    icon2: DashboardIconWhite,
    to: "/md/dashboard",
  },
  {
    title: "Users",
    icon: usersvg,
    icon2: UserIconWhite,
    to: "/md/users",
  },
  {
    title: "Fund Requests",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/md/cred-req",
  },
  {
    title: "Transactions",
    icon: graph,
    icon2: ReportsIcon,
    to: "/md/transactions",
  },
  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/md/account-ledger",
  },
  // {
  //   title: "Contact Us",
  //   icon: <SupportAgentIcon />,
  //   to: "/ad/cred-req",
  // },
  {
    title: "Invoices",
    icon: employee1,
    icon2: employeesIconWhite,
    to: "/md/invoice",
  },
  {
    title: "Login History",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/md/loginHistory",
  },
];
// this is the nav for the old layout
export const customer_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/customer/dashboard",
  },
  {
    title: "Users",
    icon: User2,
    icon2: UserIconWhite,
    to: "/customer/users",
  },
  // {
  //   title: "Merchants",
  //   icon: mservice,
  //   icon2: RechargeIcon,
  //   to: "/customer/services",

  // },

  {
    title: "Projects",
    icon: Project,
    icon2: ledgerIcon,
    to: "/customer/project",
  },
  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/customer/task",
  },
  {
    title: "Attendance",
    icon: Attend,
    icon2: Attend1,
    to: "/customer/attendance",
  },
  {
    title: "Leave Request",
    icon: Leave,
    icon2: ledgerIcon,
    to: "/customer/leave",
  },
  {
    title: "Holiday",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/customer/holiday",
  },
  {
    title: "Attandance Emp",
    icon: Attend,
    icon2: Attend1,
    to: "/customer/attandanceEmp",
  },
  {
    title: "Developers",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/customer/developers",
  },
  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/customer/loginHistory",
  },
  {
    title: "Tickets",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/customer/tickets",
  },
  {
    title: "Employee Salary",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/customer/employee-salary",
  },
  {
    title: "Invoice",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/customer/invoicedata",
  },
  {
    title: "Expenses",
    icon: loginhistory,
    // icon2: TransactionIconWhite,
    to: "/customer/expenses",
  },
  {
    title: "Our Clients",
    icon: loginhistory,

    to: "/customer/clients",
    subMenu: [
      { title: "Clients", to: "/customer/clients" },
      { title: "Client Profile", to: "/customer/clientprofile" },
    ],
  },
];
export const developers_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/developer/dashboard",
  },

  {
    title: "Projects",
    icon: Project,
    icon2: ledgerIcon,
    to: "/developer/project",
  },
  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/developer/task",
  },
  {
    title: "Employee ",
    icon: UTILITY,
    to: "/developer/clients",
    subMenu: [
      {
        title: "Attendance",
        to: "/developer/attendance",
        icon: Attend,
        icon2: Attend1,
      },
      {
        title: "Employee Leaves",
        to: "/developer/employeeleave",
        icon: Leave,
        icon2: ledgerIcon,
      },
      // {
      //   title: "Leaves",
      //   to: "/admin/totalleave",
      //   icon: Leave,
      //   icon2: ledgerIcon
      // },
      // {
      //   title: "Leave Request",
      //   to: "/admin/leave",
      //   icon: Leave,
      //   icon2: ledgerIcon
      // },
      // {
      //   title: "Salary",
      //   to: "/developer/salary",
      //   icon: Leave,
      //   icon2: ledgerIcon,
      // },
      // {
      //   title: "Emoployee",
      //   to: "/developer/employee",
      //   icon: Leave,
      //   icon2: ledgerIcon,
      // },
    ],
  },
  {
    title: "Assets",
    icon: Task,
    icon2: ledgerIcon,
    to: "/developer/assets",
  },
  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/developer/loginHistory",
  },
];
export const merchants_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/merchant/dashboard",
  },

  {
    title: "Projects",
    icon: Project,
    icon2: ledgerIcon,
    to: "/merchant/project",
  },
  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/merchant/task",
  },
  {
    title: "Invoice",
    icon: Task,
    icon2: ledgerIcon,
    to: "/merchant/invoice",
  },

  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/merchant/loginHistory",
  },
];
export const backend_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/backend/dashboard",
  },

  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/backend/task",
  },
  {
    title: "Attendance",
    icon: Attend,
    icon2: Attend1,
    to: "/backend/attendance",
  },
  {
    title: "Leave Request",
    icon: Leave,
    icon2: ledgerIcon,
    to: "/backend/employeeleave",
  },

  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/backend/loginHistory",
  },
  // {
  //   title: "Tickets",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/backend/tickets",
  // },
  // {
  //   title: "Employee Salary",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/backend/employee-salary",
  // },
  // {
  //   title: "My Profile",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/backend/my_profile",
  // },
  // {
  //   title: "Utility",
  //   icon: UTILITY,
  //   // icon2: TransactionIconWhite,
  //   to: "/backend/utility",
  // },
];
export const accounts_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/accounts/dashboard",
  },

  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/accounts/task",
  },
  {
    title: "Attendance",
    icon: Attend,
    icon2: Attend1,
    to: "/accounts/attendance",
  },
  {
    title: "Leave Request",
    icon: Leave,
    icon2: ledgerIcon,
    to: "/accounts/leave",
  },

  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/accounts/loginHistory",
  },
];
export const trainee_nav = [
  {
    title: "Dashboard",
    icon: DASH,
    icon2: DashboardIconWhite,
    to: "/trainee/dashboard",
  },

  {
    title: "Projects",
    icon: Project,
    icon2: ledgerIcon,
    to: "/trainee/project",
  },
  {
    title: "Task",
    icon: Task,
    icon2: ledgerIcon,
    to: "/trainee/task",
  },
  {
    title: "Attendance",
    icon: Attend,
    icon2: Attend1,
    to: "/trainee/attendance",
  },
  {
    title: "Leave Request",
    icon: Leave,
    icon2: ledgerIcon,
    to: "/trainee/leave",
  },

  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/trainee/loginHistory",
  },
  // {
  //   title: "Tickets",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/trainee/tickets",
  // },
  // {
  //   title: "Employee Salary",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/trainee/employee-salary",
  // },
  // {
  //   title: "My Profile",
  //   icon: loginhistory,
  //   // icon2: TransactionIconWhite,
  //   to: "/trainee/my_profile",
  // },
  // {
  //   title: "Utility",
  //   icon: UTILITY,
  //   // icon2: TransactionIconWhite,
  //   to: "/trainee/utility",
  // },
];
export const customer_nav2 = [
  {
    title: "Dashboard",
    icon: dashbaordsvg,
    icon2: DashboardIconWhite,
    to: "/customer/dashboard",
  },
  {
    title: "Money Transfer",
    icon: dashbaordsvg,
    icon2: DashboardIconWhite,
    to: "/customer/money_transfer",
  },
  {
    title: "Wallet Transfer",
    icon: dashbaordsvg,
    icon2: DashboardIconWhite,
    to: "/customer/wallet_transfer",
  },
  {
    title: "Payments",
    icon: Arrow,
    icon2: DashboardIconWhite,
    to: "/customer/payment_transfer",
  },
  {
    title: "Upi Transfer",
    icon: upi,
    icon2: DashboardIconWhite,
    to: "/customer/upi-transfer",
  },
  {
    title: "Nepal Transfer",
    icon: NepalIcon,
    icon2: nepal2,
    to: "/customer/nepal-transfer",
  },
  {
    title: "Aeps",
    icon: AepsIcon,
    icon2: DashboardIconWhite,
    to: "/customer/aeps",
  },

  {
    title: "Irctc",
    icon: trainIconWhite,
    icon2: trainIconWhite,
    to: "https://www.irctc.co.in/nget/train-search",
  },
  {
    title: "Recharge/Bill",
    icon: Recharge,
    icon2: RechargeIcon,
    to: "/customer/recharge_new",
  },
  {
    title: "BBPS",
    icon: bharatbig,
    icon2: BbpsIcon,
    to: "/customer/bbps",
  },
  {
    title: "CMS",
    icon: Cms2,
    icon2: cmsIconWhite,
    to: "/customer/cms_new",
  },
  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/customer/account-ledger",
  },
  {
    title: "Fund Request",
    icon: creditReqBadgeIcon,
    icon2: CreditRequestIcon,
    to: "/customer/cred-req",
  },
  {
    title: "Transactions",
    icon: transactionsvg,
    icon2: ReportsIcon,
    to: "/customer/transactions",
  },

  {
    title: "My Complaints",
    icon: complaintsvg,
    icon2: ComplaintsIconWhite,
    to: "/customer/complaints",
  },

  {
    title: "My Purchase",
    icon: purchasesvg,
    icon2: TransactionIconWhite,
    to: "/customer/purchase",
  },
  {
    title: "My Sale",
    icon: mysale,
    icon2: TransactionIconWhite,
    to: "/customer/sale",
  },
  {
    title: "IRCTC",
    icon: train,
    icon2: trainIconWhite,
    to: "https://www.irctc.co.in/nget/train-search",
  },
  {
    title: "Invoices",
    icon: invoicesvg,
    icon2: employeesIconWhite,
    to: "/customer/invoice",
  },
  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/customer/loginHistory",
  },
];

// ******************************************************************
// #############################################
// these are the navs for the new layout
// #############################################
// ******************************************************************
export const reports = [
  {
    title: "Dashboard",
    icon: dashboard,
    to: "/customer/dashboard",
  },
  {
    title: "My Transactions",
    icon: transactions,
    to: "/customer/transactions",
  },
  {
    title: "Account Ledger",
    icon: account_ledgre,
    to: "/customer/account-ledger",
  },
  {
    title: "Account Ledger",
    icon: account_ledgre,
    to: "/customer/account-ledger",
  },
  {
    title: "Fund Request",
    icon: creditReqBadgeIcon,
    to: "/customer/cred-req",
  },
  {
    title: "My Complaints",
    icon: myComplaints,
    to: "/customer/complaints",
  },
  {
    title: "Credit Report",
    icon: myPurchase,
    to: "/customer/purchase",
  },
  {
    title: "Khata Book",
    icon: khataBook,
    to: "/customer/khata-book",
  },
  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/customer/loginHistory",
  },
];

export const banking = [
  {
    title: "Money Transfer",
    icon: mtIcon,
    to: "/customer/money-transfer",
  },
  {
    title: "Settlements",
    icon: stIcon,
    to: "/customer/settlements",
  },
  {
    title: "Express Transfer",
    icon: etIcon,
    to: "/customer/express-transfer",
  },
  {
    title: "Super Transfer",
    icon: stIcon,
    to: "/customer/super-transfer",
  },
  {
    title: "AEPS",
    icon: aepsIcon,
    to: "/customer/aeps",
  },
  {
    title: "Nepal Transfer",
    icon: ntIcon,
    to: "/customer/nepal-transfer",
  },
  {
    title: "CMS",
    icon: CMSIcon,
    to: "/customer/cms",
  },
  {
    title: "UPI Transfer",
    icon: utIcon,
    to: "/customer/upi-transfer",
  },
  {
    title: "Login History",
    // icon: loginHistory,
    // icon2: TransactionIconWhite,
    to: "/customer/loginHistory",
  },
];

export const bbpsServices = [
  {
    title: "Electricity",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Gas Cylinder",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Mobile Postpaid",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Mobile Prepaid",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "FASTag",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Piped Gas",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "BBPS",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
  },
];
export const ourServices = [
  {
    title: "Mobile Recharge",
    icon: Prepaid,
    to: "",
    isModal: true,
  },
  {
    title: "DTH Recharge",
    icon: dthIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Electricity with commission",
    icon: elecIcon,
    to: "",
    isModal: true,
  },
  {
    title: "LIC Premium",
    icon: licIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Credit Card Bill",
    icon: cardIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Gas Bill",
    icon: gasIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Broadband Bill",
    icon: bbIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Water Bill",
    icon: waterIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Landline Bill",
    icon: landIcon,
    to: "",
    isModal: true,
  },
  // {
  //   title: "Recharges",
  //   icon: Prepaid,
  //   to: "/customer/recharge",
  // },
];

export const travelServices = [
  {
    title: "Flight Booking",
    icon: flightBooking,
    to: "/customer/travel",
  },
  {
    title: "IRCTC Booking",
    icon: irctcTravelImage,
    to: "https://www.irctc.co.in/nget/train-search",
    target: "_blank",
  },
  {
    title: "Hotel Booking",
    icon: hotelBooking,
    to: "/customer/travel",
  },
  {
    title: "Bus Booking",
    icon: busBooking,
    to: "/customer/travel",
  },
];

export const getNavImg = (title) => {
  let image;
  switch (title) {
    case "Electricity":
      image = Electricity;
      break;
    case "FASTag":
      image = FASTag;
      break;
    case "BBPS":
      image = BBPS;
      break;
    case "Gas Cylinder":
      image = Cylinder;
      break;
    case "Mobile Postpaid":
      image = Postpaid;
      break;
    case "Mobile Prepaid":
      image = Prepaid;
      break;
    case "Piped Gas":
      image = Gas;
      break;

    default:
      image = BBPS;
  }
  return image;
};

// export const customer_nav_super = [
//   {
//     title: "Dashboard",
//     icon: <HomeOutlinedIcon />,
//     to: "/customer/dashboard",
//   },
//   {
//     title: "Recharge/Bill",
//     icon: <RechargeIconutlinedIcon />,
//     to: "/customer/RechargeIcon",
//   },
//   {
//     title: "BBPS",
//     icon: <FormatBoldIcon />,
//     to: "/customer/bbps",
//   },
//   {
//     title: "Money Transfer",
//     icon: <SwapHorizIcon />,
//     to: "/customer/money-transfer",
//   },
//   {
//     title: "Express Transfer",
//     icon: <SwipeRightOutlinedIcon />,
//     to: "/customer/express-transfer",
//   },
//   {
//     title: "Super Transfer",
//     icon: <BoltIcon />,
//     to: "/customer/super-transfer",
//   },
//   {
//     title: "UPI Transfer",
//     // icon: <SyncAltOutlinedIcon />,
//     icon: <QrCodeScannerIcon />,
//     to: "/customer/upi-transfer",
//   },
//   {
//     title: "AEPS",
//     icon: <TouchAppOutlinedIcon />,
//     to: "/customer/aeps",
//   },
//   {
//     title: "My Transactions",
//     icon: <ShuffleIcon />,
//     to: "/customer/transactions",
//   },
//   {
//     title: "Fund Request",
//     icon: <CurrencyRupeeOutlinedIcon />,
//     to: "/customer/cred-req",
//   },
//   {
//     title: "My Complaints",
//     icon: <SupportAgentIcon />,
//     to: "/customer/complaints",
//   },
//   {
//     title: "Credit Report",
//     icon: <FontAwesomeIcon icon={faLink} style={{ fontSize: "18px" }} />,
//     to: "/customer/purchase",
//   },
//   {
//     title: "Khata Book",
//     icon: <MenuBookOutlinedIcon />,
//     to: "/customer/khata-book",
//   },
// ];
export const account_nav = [
  // {
  //   title: "Dashboard",
  //   icon: DashboardIcon,
  //   icon2: DashboardIconWhite,
  //   to: "/account/dashboard",
  // },
  {
    title: "Users",
    icon: usersvg,
    icon2: UserIconWhite,
    to: "/account/users",
  },

  {
    title: "Banking",
    icon: bankingsvg,
    icon2: BankIconWhite,
    to: "/account/banking",
  },
  {
    title: "Transaction Data",
    icon: transactionsvg,
    icon2: ReportsIcon,
    to: "/account/transactions",
  },
  {
    title: "Reports",
    icon: dashbaordsvg,
    icon2: ReportsIcon,
    to: "/account/reports",
  },
  // {
  //   title: "Download",
  //     icon: transactionsvg,
  //     icon2: ReportsIcon,
  //   to: "/account/transactions",
  // },

  {
    title: "Login History",
    icon: Login,
    // icon2: TransactionIconWhite,
    to: "/account/loginHistory",
  },
];

//acc login
//user
//bank
//account
//txn
